import { useTranslation } from 'react-i18next'
import { Wrapper, EmptyAwards, WineDescription } from './_styles'
import AwardItem from './AwardItem'

const Awards = ({ product }) => {
  const { t } = useTranslation()

  const wine = product?.wine

  const notSpecified = t('common.notSpecified')

  // поддерживаем оба формата: { wineAward } и { award, year, minScore, maxScore, rewards }
  const normalizeAward = a => {
    const wa = a.wineAward ?? a
    return {
      id: wa.award?.id ?? a.award?.id ?? Math.random(),
      year: wa.year ?? a.year ?? notSpecified,
      award: wa.award ?? a.award,
      minScore: wa.minScore ?? a.minScore,
      maxScore: wa.maxScore ?? a.maxScore,
      rewards: wa.rewards ?? a.rewards ?? [],
    }
  }

  const awards = [...(wine?.techSheet?.awards ?? [])]
    .sort((a, b) => {
      const ya = Number((a.wineAward ?? a).year)
      const yb = Number((b.wineAward ?? b).year)
      return ya - yb
    })
    .slice(0, 6)

  const description = wine?.techSheet?.marketingNote ?? ''
  const adaptedAwards = awards.map(normalizeAward)
  return (
    <Wrapper>
      {adaptedAwards.length > 0 &&
        adaptedAwards.map(item => <AwardItem key={item?.id} award={item} />)}

      {adaptedAwards.length === 0 && !description && (
        <EmptyAwards>{t('wine.techlist.awardsPlace')}</EmptyAwards>
      )}

      {(adaptedAwards.length === 0 || adaptedAwards.length <= 2) &&
        description && (
          <WineDescription align={adaptedAwards.length > 0 ? 'left' : 'center'}>
            {description.split('\n').map((paragraph, index) => (
              <div key={index}>{paragraph}</div>
            ))}
          </WineDescription>
        )}
    </Wrapper>
  )
}

export default Awards
